export default __webpack_public_path__ + "static/media/ic_payment_b.7ab65430.svg";